<template>
  <div>
    <!-- <div class="wrapper_gltfManager"></div>
      -->

    </div>
</template>
<script>
import {mapGetters} from "vuex"
import {mapActions} from "vuex"
import {
  Transforms,
  Cartesian3,
  Model,
  Matrix4,
  Matrix3,
  Math as cesiumMath,
  Cesium3DTileset
} from 'cesium';
import cesiumUtil from '../../../utils/cesiumUtils';


export default{
    data(){
        return {
            tableData: [],
            V:null,
            GltfModel:null,
            models:{},

        }
    },
    computed:{
        ...mapGetters({
            getter_currentAttributeDrawed:"getter_currentAttributeDrawed"
        }),
        allEntities(){
            return this.D3Config.Viewer.entities.values;
        }
    },
    methods:{
        ...mapActions({
            change_addBoxWindow_Visual:"change_addBoxWindow_Visual"
        }),
        //显示模型图层
        showModel(){
            this.$nextTick(()=>{
              this.tableData=this.D3Config.models;
              // debugger;
              this.generateAllGltf(this.tableData);
            })
       
        },
       
       
        generateAllGltf(data){
          let V=this.D3Config.Viewer;
          let that=this;
        
          that.models={};
          data.forEach(function(_gltf,index){
            try{
             
            var modelMatrix = Transforms.eastNorthUpToFixedFrame(Cartesian3.fromDegrees(_gltf.coors[0], _gltf.coors[1], 0.0));
            var model = that.D3Config.Viewer.scene.primitives.add(
              Model.fromGltf({
                id:Math.random(),
                url: _gltf.modelUrl+"?k="+new Date().valueOf(),
                modelMatrix: modelMatrix,
                scale: _gltf.scale,
     
               // debugWireframe : true
              }));
            model.name=_gltf.name
            
            let _model={
              name:_gltf.name,
              model:model,
              visible:true
            }
            that.models[_gltf.name]=_model;

            that.GltfModel=model;

            //旋转
          //  Matrix4.multiplyByMatrix3(model.modelMatrix, Matrix3.fromRotationZ(cesiumMath.toRadians(343)),model.modelMatrix)
          Matrix4.multiplyByMatrix3(
            model.modelMatrix,
            Matrix3.fromRotationZ(cesiumMath.toRadians(_gltf.rotateZ)), //绕z轴旋转角
            model.modelMatrix
          );
            //平移
            // Matrix4.multiply(model.modelMatrix,Matrix4.fromTranslation(new Cartesian3(40,60,0)),model.modelMatrix)
            Matrix4.multiply(
              model.modelMatrix,
              Matrix4.fromTranslation(
                new Cartesian3(_gltf.heading, _gltf.pitch, 0) //x,y,z
              ),
              model.modelMatrix
            );
            }catch(e){
              console.log("模型渲染出错",e);
            }
            
          })
        }
    },
    created(){
     
    },

    mounted(){
    //  this.showModel();
    },
    watch:{

    }
}
</script>
<style>
.wrapper_gltfManager{
    position:absolute;
    right:10px;
    top:100px;
    padding:15px;
    box-sizing: border-box;
    background: #0000ff59;
    max-height:60vh;
    overflow-y:scroll;
}
</style>
